import styles from './ProjectContentBlock.module.scss';
import classnames from 'classnames';
import { isMobile } from 'react-device-detect';

const ProjectContentBlock = ({ props }) => {
  return (
    <section
      className={classnames(styles.projectContentBlock, {
        [styles.mobile]: isMobile,
      })}>
      {props.map((item) => {
        return (
          <div
            className={classnames(styles.section, {
              [styles.mobile]: isMobile,
              [styles.single]: props.length === 1,
            })}
            key={item.id}>
            <h2 className={classnames(isMobile ? [styles.title, styles.mobile] : [styles.title])}>{item.title}</h2>

            {item.image && (
              <div className={classnames(isMobile ? [styles.image, styles.mobile] : [styles.image])}>
                <img src={item.image} alt={item.title} />
              </div>
            )}

            <div
              className={classnames(isMobile ? [styles.text, styles.mobile] : [styles.text])}
              dangerouslySetInnerHTML={{ __html: item.text }}
            />
          </div>
        );
      })}
    </section>
  );
};

export default ProjectContentBlock;
